export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';

export const PageMap = {
  THANK_YOU_PAGE: 'thank_you_page',
  CHECKOUT: 'checkout',
};

export const RESULT_PROP_NAME = 'expressCheckoutButtonsResult';
export const FQDN = 'wix.ecom.*.checkout';

export const FORMS_TEMPLATE_IDS = {
  CUSTOMER_DETAILS_WO_ADDITIONAL_INFO: '3f63d41e-9b8e-4631-bfe0-e984965ad618',
};

export enum FormFieldTarget {
  additional_info_1 = 'additional_info_1',
}

export enum FastFlowRedirectionReason {
  hasTermsAndConditions = 'hasTermsAndConditions',
  hasRequiredPolicies = 'hasRequiredPolicies',
  shouldChooseShippingMethod = 'shouldChooseShippingMethod',
  hasCustomField = 'hasCustomField',
  hasViolations = 'hasViolations',
  hasTotalAmountMismatchWithLatestSeen = 'hasTotalAmountMismatch',
  hasTaxZipCodeError = 'hasTaxZipCodeError',
  hasTaxSubdivisionError = 'hasTaxSubdivisionError',
  hasShippingZipCodeError = 'hasShippingZipCodeError',
  hasShippingSubdivisionError = 'hasShippingSubdivisionError',
  hasLineItemPolicies = 'hasLineItemPolicies',
  hasMemberOnlyCheckout = 'hasMemberOnlyCheckout',
}
